import { Avatar as AvatarPrimitive } from 'radix-ui';
import { ComponentPropsWithoutRef, FunctionComponent } from 'react';

import {
  UI_SHAPE,
  UiShape,
} from '@savgroup-front-common/constants/shared/shape';
import {
  $AvatarBadge,
  $AvatarFallback,
  $AvatarGroup,
  $AvatarGroupCount,
  $AvatarImage,
  $AvatarRoot,
} from './Avatar.styles';
import { AVATAR_SIZE, AvatarSize, AvatarVariant } from './Avatar.types';

interface AvatarProps extends ComponentPropsWithoutRef<
  typeof AvatarPrimitive.Root
> {
  size?: AvatarSize;
  shape?: UiShape;
  variant?: AvatarVariant;
  isHeader?: boolean;
}

type AvatarImageProps = ComponentPropsWithoutRef<typeof AvatarPrimitive.Image>;

type AvatarFallbackProps = ComponentPropsWithoutRef<
  typeof AvatarPrimitive.Fallback
>;

type AvatarBadgeProps = ComponentPropsWithoutRef<'span'>;

type AvatarGroupProps = ComponentPropsWithoutRef<'div'>;

type AvatarGroupCountProps = ComponentPropsWithoutRef<'div'>;

const Avatar: FunctionComponent<AvatarProps> = ({
  size = AVATAR_SIZE.MD,
  shape = UI_SHAPE.ROUND,
  isHeader = false,
  variant,
  ...props
}) => {
  return (
    <$AvatarRoot
      data-slot="avatar"
      data-size={size}
      data-shape={shape}
      data-is-header={isHeader}
      data-variant={variant}
      {...props}
    />
  );
};

const AvatarImage: FunctionComponent<AvatarImageProps> = (props) => {
  return <$AvatarImage data-slot="avatar-image" {...props} />;
};

const AvatarFallback: FunctionComponent<AvatarFallbackProps> = (props) => {
  return <$AvatarFallback data-slot="avatar-fallback" {...props} />;
};

const AvatarBadge: FunctionComponent<AvatarBadgeProps> = (props) => {
  return <$AvatarBadge data-slot="avatar-badge" {...props} />;
};

const AvatarGroup: FunctionComponent<AvatarGroupProps> = (props) => {
  return <$AvatarGroup data-slot="avatar-group" {...props} />;
};

const AvatarGroupCount: FunctionComponent<AvatarGroupCountProps> = (props) => {
  return <$AvatarGroupCount data-slot="avatar-group-count" {...props} />;
};

export {
  Avatar,
  AvatarImage,
  AvatarFallback,
  AvatarBadge,
  AvatarGroup,
  AvatarGroupCount,
};
